<template>
	<div id="subscription">
		<SubpageHeader
			@on-back="actionBack"
		>
			利用履歴
		</SubpageHeader>
		<div class="container-block">
			<div class="container">
				<div class="centerblock">
					<div class="history">
						<HeaderCaption>利用状況</HeaderCaption>
						<div class="history_loading" v-if="isRunningRunstLog">
							<LoadingMark>
							</LoadingMark>
						</div>
						<div v-if="!isRunningRunstLog" class="history_list">
							<table v-if="existRunstLog" class="history_table">
								<tbody>
									<tr v-for="history, index in listRunningRunstLog" :key="index">
										<td>{{historyDate(history)}}</td>
										<td>{{historyContent(history)}}</td>
									</tr>
								</tbody>
							</table>
							<div v-else class="notrslog">
								利用状況はありません。
							</div>
						</div>
					</div>

				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import SubpageHeader from '@/components/SubpageHeader';
	import HeaderCaption from '@/components/common/HeaderCaption';
	import LoadingMark from '@/components/LoadingMark';
	import {ymdToText} from '@/lib/formatter';

	export default {
		components: {
			SubpageHeader,
			HeaderCaption,
			LoadingMark
		},
		props: {
		},
		data() {
			return {
			}
		},
		computed: {
			// ランステ利用状況取得中
			isRunningRunstLog() {
				return this.$store.getters['commonStore/getRunningRunstLog'];
			},
			// ランステ利用状況リスト
			listRunningRunstLog() {
				const runst_list = this.$store.getters['commonStore/getListRunstLog'];
				return runst_list;
			},
			// ランステ利用状況が存在するか
			existRunstLog() {
				const runst_list = this.$store.getters['commonStore/getListRunstLog'];
				return runst_list && Array.isArray(runst_list) && runst_list.length;
			},
		},
		methods: {
			actionBack() {
				this.$router.push('/top');
			},
			historyDate(history) {
				return ymdToText(history.ymd);
			},
			historyContent(history) {
				return history.desc;
			},
		},
		mounted() {
			this.$store.dispatch('commonStore/apiMonthlyLog').then(() => {
			});
		}
	};
</script>

<style lang="scss" scoped>
	#subscription {
		margin: 0 auto;
		padding: 0;
		height: 100vh;
		
		.container-block {	
			padding: 8px;
			.container {
				width: 100%;
				display: flex;
				justify-content: center;
				align-items: center;
				.centerblock {
					.history {
						.history_list {
							padding: 8px;
						}
						.history_loading {
							width: 32px;
							height: 32px;
							margin: 0 auto;
						}
						table {
							font-size: 12px;
							width: auto;
							&.history_table {
								td:nth-child(1) {
									text-align: center;
									min-width: 90px;
									vertical-align: top;
								}
								td {
									padding-top: 4px;
									padding-bottom: 4px;
									border-bottom: dotted 1px #eee;
								}
							}
						}
						.notrslog {
							font-size: 14px;
							line-height: 1.7;
						}
					}

				}
			}
		}
	}
</style>
